export const scrollToLinks = () => {

	const stickyElement = document.querySelector('.scroll-to-links');

	if(stickyElement) {

  		const computedStyle = window.getComputedStyle(stickyElement);

		// Extract the top value (it will be a string, so we parse it into a number)
		const topValue = parseInt(computedStyle.top, 10) || 0;

		// Listen to the scroll event
		window.addEventListener('scroll', function() {
			const stickyPosition = stickyElement.getBoundingClientRect().top;

			// Detect when the element becomes sticky using dynamic top value
			if (stickyPosition <= topValue) {
				stickyElement.classList.add('is-sticky'); // Add the class when sticky
			} else {
				stickyElement.classList.remove('is-sticky'); // Remove the class when not sticky
			}
		});
  	}
}